import { WEB_MESSAGE_TYPES as e } from "@template/types";
e.NAVIGATE_BACK, e.FILE_DOWNLOAD, e.FILE_UPLOAD, e.READY, e.SET_THEME, e.REFRESH_TOKEN, e.RAW;
function i() {
  return typeof window < "u" && !!window.ReactNativeWebView?.postMessage;
}
export {
  i as isNativeWebView
};
